export const COLORS = {
    pink: 'rgb(231,138,138)',
    yellow: 'rgb(230,228,87)',
    aqua: 'rgb(175,235,230)',
    green: 'rgb(81,135,115)',
    orange: 'rgb(234,138,61)',
};
